import React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { Box, Typography } from '@mui/material'
import Container from 'src/designSystem/Container/Container'
import AdvancedInfoArea from '../AdvancedInfoArea'
import AdvancedPatientView from '../AdvancedPatientView'
import AdvancedThemeProvider from '../AdvancedThemeProvider'
import { AdvancedOverviewProvider } from '../api/AdvancedOverviewProvider'
import { advancedColors } from '../theme'
import { TourExampleProvider } from '../tour/tourExample'
import { PatientHeaderSizeProvider } from '../components/PatientHeaderSize'
import AdvancedSidebar from './AdvancedSidebar'

export type Props = RouteComponentProps<{ uid?: string }>

// Standard's list widths with priority filters, which its filter row needs to fit, labelled when expanded.
const SIDEBAR_WIDTH = 440
const MIN_EXPANDED_SIDEBAR_WIDTH = 980

const SelectPrompt = () => (
  <Box
    sx={{
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      p: 4,
      backgroundColor: advancedColors.canvas,
    }}
  >
    <Typography variant="h3" align="center" sx={{ maxWidth: 300, color: advancedColors.inkMuted }}>
      Select a participant to view their Advanced tracks
    </Typography>
  </Box>
)

const AdvancedHome = ({ match }: Props) => {
  const { uid } = match.params

  const sidebar = (
    <AdvancedThemeProvider>
      <AdvancedSidebar selectedUid={uid} />
    </AdvancedThemeProvider>
  )

  // One tree with or without a patient, so opening or closing one keeps the sidebar and its filters mounted.
  return (
    <TourExampleProvider>
      <PatientHeaderSizeProvider>
        <AdvancedOverviewProvider uid={uid}>
          <Container
            sidebar={sidebar}
            sidebarWidth={SIDEBAR_WIDTH}
            minExpandedSidebarWidth={MIN_EXPANDED_SIDEBAR_WIDTH}
            sidebarPaperBackgroundColor={advancedColors.deep}
            forceShowSidebar={!uid}
            selectedUid={uid}
            infoarea={
              uid ? (
                <AdvancedThemeProvider>
                  <AdvancedInfoArea uid={uid} />
                </AdvancedThemeProvider>
              ) : undefined
            }
            infoareaPaperBackgroundColor={advancedColors.deep}
          >
            <AdvancedThemeProvider>{uid ? <AdvancedPatientView uid={uid} /> : <SelectPrompt />}</AdvancedThemeProvider>
          </Container>
        </AdvancedOverviewProvider>
      </PatientHeaderSizeProvider>
    </TourExampleProvider>
  )
}

export default AdvancedHome
